<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="comu-prefs">
    <div class="has-side-bars">
      <div class="top-wrap">
        <h3>{{ $t('comun_pref') }}</h3>
        <div
          v-if="!isMobile"
          class="save-button"
          :class="!hasChanged && 'disabled'"
          @click="userNotifChanged"
        >
          <span>{{ $t('save') }}</span>
        </div>
      </div>
      <div class="pref-noti">
        <div class="pref-info">
          <span class="pref-title">{{ $t('pref_noti_favs_default_title') }}</span>
          <span class="pref-desc">{{ $t('pref_noti_favs_default_desc') }}</span>
        </div>
        <div class="notify-wrap">
          <span v-if="notiFavsDefault" class="noti-act">{{ $t('pref_noti_active') }}</span>
          <label class="switch">
            <input v-model="notiFavsDefault" type="checkbox">
            <span class="slider round" />
          </label>
        </div>
      </div>
      <div class="pref-wrapper">
        <div class="comun-left">
          <div class="pref-noti pref-noti-check">
            <div class="pref-info">
              <span class="pref-title">{{ $t('pref_noti_title') }}</span>
              <span class="pref-desc">{{ $t('pref_noti_desc') }}</span>
            </div>
            <div class="notify-wrap">
              <span v-if="notifyCheck" class="noti-act">{{ $t('pref_noti_active') }}</span>
              <label v-tooltip="$t('update_noti')" class="switch">
                <input v-model="notifyCheck" type="checkbox">
                <span class="slider round" />
              </label>
            </div>
          </div>
          <span class="question">{{ $t('tem_new_cont') }}</span>
          <ThemesGrid :thesaurus="thesaurus" :internal-checks="internalChecks" @change-internal-checks="changeInternalChecks" />
        </div>
      </div>
      <div v-if="notifyCheck" class="comun-noti">
        <span class="question">{{ $t('temp_freq_news') }}</span>
        <div class="op-wrap">
          <div class="radio-wrap">
            <input
              id="week"
              type="radio"
              name="freq_com"
              value="WEEKLY"
              :checked="freqVal === 'WEEKLY'"
              @click="changeFreqVal('WEEKLY')"
            >
            <span>{{ $t('temp_week') }}</span>
          </div>
          <div class="radio-wrap">
            <input
              id="month"
              type="radio"
              name="freq_com"
              value="MONTHLY"
              :checked="freqVal === 'MONTHLY'"
              @click="changeFreqVal('MONTHLY')"
            >
            <span>{{ $t('temp_month') }}</span>
          </div>
        </div>
      </div>
      <div
        v-if="isMobile"
        class="save-button"
        :class="!hasChanged && 'disabled'"
        @click="userNotifChanged"
      >
        <span>{{ $t('save') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getThesaurus } from '@/services/api'
import { getUserNotif, setUserNotif } from '@/services/user-api'
import ThemesGrid from './ThemesGrid.vue'
export default {
  components: { ThemesGrid },
  props: {},
  data() {
    return {
      notifyCheck: false,
      notiFavsDefault: false,
      freqVal: '',
      internalChecks: [],
      startNotifyCheck: false,
      startNotiFavsDefault: false,
      startFreqVal: '',
      startInternalChecks: [],
      hasChanged: false,
    }
  },
  asyncComputed: {
    thesaurus() {
      return getThesaurus(this.$store.state.i18n.lang)
    },
    currentUserNotif() {
      return getUserNotif(this.$store.state.i18n.lang).then(resp => {
        if (resp.code === 500 || resp.code === 404 || resp.code === 401) {
          this.$store.dispatch('deleteUser').then(() => this.$router.push({ name: 'Cover' }))
        }
        return resp
      })
    },
  },
  computed: {},
  watch: {
    currentUserNotif() {
      this.notifyCheck = this.currentUserNotif.enabled
      this.notiFavsDefault = this.currentUserNotif.defaultNotificationsFavourite
      this.freqVal = this.currentUserNotif.frequency
      this.startNotifyCheck = this.notifyCheck
      this.startNotiFavsDefault = this.notiFavsDefault
      this.startFreqVal = this.freqVal
      if (this.thesaurus !== null) {
        this.changeIC()
      }
    },
    thesaurus() {
      if (this.currentUserNotif?.themes) {
        this.changeIC()
      }
    },
    notifyCheck() {
      if (this.notifyCheck !== this.startNotifyCheck) this.hasChanged = true
      else if (this.notiFavsDefault !== this.startNotiFavsDefault || this.freqVal !== this.startFreqVal || JSON.stringify(this.internalChecks) !== JSON.stringify(this.startInternalChecks)) this.hasChanged = true
      else this.hasChanged = false
    },
    notiFavsDefault() {
      if (this.notiFavsDefault !== this.startNotiFavsDefault) this.hasChanged = true
      else if (this.notifyCheck !== this.startNotifyCheck || this.freqVal !== this.startFreqVal || JSON.stringify(this.internalChecks) !== JSON.stringify(this.startInternalChecks)) this.hasChanged = true
      else this.hasChanged = false
    },
    freqVal() {
      if (this.freqVal !== this.startFreqVal) this.hasChanged = true
      else if (this.notifyCheck !== this.startNotifyCheck || this.notiFavsDefault !== this.startNotiFavsDefault || JSON.stringify(this.internalChecks) !== JSON.stringify(this.startInternalChecks)) this.hasChanged = true
      else this.hasChanged = false
    },
  },
  methods: {
    changeFreqVal(val){
      this.freqVal = val
    },
    simplifyedInternalChecks(checks) {
      let finalChecks = []
      let splitted = checks.map(el => el.split(','))
      let lvl1 = splitted.filter(el => el.length === 1)
      lvl1.forEach(el => {
        finalChecks.push(el[0])
      })
      let lvl2 = splitted.filter(el => el.length === 2)
      lvl2.forEach(el => {
        if (finalChecks.indexOf(el[0]) === -1) {
          finalChecks.push(el.join(','))
        }
      })
      let lvl3 = splitted.filter(el => el.length === 3)
      lvl3.forEach(el => {
        if (finalChecks.indexOf(el[0]) === -1 && finalChecks.indexOf(el[0] + ',' + el[1]) === -1) {
          finalChecks.push(el.join(','))
        }
      })
      return finalChecks
      
    },
    changeIC() {
      this.internalChecks = this.parseInternalChecks(this.currentUserNotif.themes)
      this.startInternalChecks = this.internalChecks
    },
    checkChildrens(saurus, father) {
      let arrayChecks = []
      saurus.subThemes?.forEach(el => {
        arrayChecks.push((father ? (father + ',') : '') + saurus.label + ',' + el.label)
        if (!father && el.subThemes) {
          el.subThemes.forEach(x => {
            arrayChecks.push(saurus.label + ',' + el.label + ',' + x.label )
          })
        }
      })
      return arrayChecks
    },
    parseInternalChecks(themes) {
      let a = this.thesaurus
      let finalChecks = []
      themes.forEach(el => {
        let v = el.split(',')
        if (v.length === 1) {
          let theme = a.theme.find(el => el.label === v[0])
          let arr = this.checkChildrens(theme)
          finalChecks = finalChecks.concat(arr)
          finalChecks.push(el)
        } else if (v.length === 2) {
          let theme = a.theme.find(el => el.label === v[0])
          let subt = theme.subThemes.find(el => el.label === v[1])
          let arr = this.checkChildrens(subt, theme.label)
          finalChecks = finalChecks.concat(arr)
          finalChecks.push(el)
        } else {
          finalChecks.push(el)
        }
      })
      return finalChecks
    },
    userNotifChanged() {
      if (this.hasChanged) {
        let selectedFreq = 'MONTHLY'
        let rads = document.getElementsByName('freq_com')
        rads.forEach(el => {
          if (el.checked) selectedFreq = el.value
        })
        setUserNotif(this.notifyCheck, selectedFreq, this.simplifyedInternalChecks(this.internalChecks), this.notiFavsDefault)
        this.hasChanged = false
      }
    },
    changeInternalChecks(val) {
      let v = val.split(',') || [val]
      if (this.internalChecks.indexOf(val) === -1) {
        let finalChecks = [...this.internalChecks]
        if (v.length === 1) {
          let theme = this.thesaurus.theme.find(el => el.label === val)
          let arr = this.checkChildrens(theme)
          let arr2 = finalChecks.concat(arr)
          let uniqueElements = new Set(arr2)
          finalChecks = [...uniqueElements]
          finalChecks.push(val)
          this.internalChecks = finalChecks
        }
        else if (v.length === 2) {
          let theme = this.thesaurus.theme.find(el => el.label === v[0])
          let subt = theme.subThemes.find(el => el.label === v[1])
          let arr = this.checkChildrens(subt, theme.label)
          let arr2 = finalChecks.concat(arr)
          let uniqueElements = new Set(arr2)
          finalChecks = [...uniqueElements]
          finalChecks.push(v.join(','))
          let x = theme.subThemes.map(el => theme.label + ',' + el.label)
          let allChildrensChecked = true
          x.forEach(el => {
            if (allChildrensChecked && finalChecks.indexOf(el) === -1) {
              allChildrensChecked = false
            }
          })
          if (allChildrensChecked) {
            finalChecks.push(v[0])
          }
          this.internalChecks = finalChecks
        } else {
          this.internalChecks.push(val)
          let theme = this.thesaurus.theme.find(el => el.label === v[0])
          let subt = theme.subThemes.find(el => el.label === v[1])
          let x = subt.subThemes.map(el => theme.label + ',' + subt.label + ',' + el.label)
          let allChildrensChecked = true
          x.forEach(el => {
            if (allChildrensChecked && this.internalChecks.indexOf(el) === -1) {
              allChildrensChecked = false
            }
          })
          if (allChildrensChecked) {
            this.internalChecks.push(v[0] + ',' + v[1])
          }
          let y = theme.subThemes.map(el => theme.label + ',' + el.label)
          allChildrensChecked = true
          y.forEach(el => {
            if (allChildrensChecked && this.internalChecks.indexOf(el) === -1) {
              allChildrensChecked = false
            }
          })
          if (allChildrensChecked) {
            this.internalChecks.push(v[0])
          }
        }
      } else {
        if (v.length === 1) {
          let theme = this.thesaurus.theme.find(el => el.label === val)
          let arr = this.checkChildrens(theme)
          let currChecks = [...this.internalChecks]
          currChecks.splice(currChecks.indexOf(val), 1)
          if (arr) {
            arr.forEach(el => {
              if (currChecks.indexOf(el) !== -1) currChecks.splice(currChecks.indexOf(el), 1)
            })
          }
          this.internalChecks = currChecks
        } else if (v.length === 2) {
          let theme = this.thesaurus.theme.find(el => el.label === v[0])
          let subt = theme.subThemes.find(el => el.label === v[1])
          let arr = this.checkChildrens(subt, theme.label)
          let currChecks = [...this.internalChecks]
          currChecks.splice(currChecks.indexOf(val) , 1)
          if (arr) {
            arr.forEach(el => {
              if (currChecks.indexOf(el) !== -1) currChecks.splice(currChecks.indexOf(el), 1)
            })
          }
          if (currChecks.indexOf(v[0]) !== -1) {
            currChecks.splice(currChecks.indexOf(v[0]), 1)
          }
          this.internalChecks = currChecks
        } else {
          this.internalChecks.splice(this.internalChecks.indexOf(v.join(',')), 1)
          v = v.slice(0, -1)
          if (this.internalChecks.indexOf(v.join(',')) !== -1) {
            this.internalChecks.splice(this.internalChecks.indexOf(v.join(',')), 1)
          }
          v = v.slice(0, -1)
          if (this.internalChecks.indexOf(v.join(',')) !== -1) {
            this.internalChecks.splice(this.internalChecks.indexOf(v.join(',')), 1)
          }
        }
      }
      if (JSON.stringify(this.internalChecks) !== JSON.stringify(this.startInternalChecks)) {
        this.hasChanged = true
      } else if (this.notiFavsDefault !== this.startNotiFavsDefault || this.notiFavsDefault !== this.startNotiFavsDefault || this.freqVal !== this.startFreqVal) {
        this.hasChanged = true
      }
      else this.hasChanged = false
    },
  },
}
</script>

<style lang="stylus" scoped>
.comu-prefs
  padding-bottom: vw(50px)
  background-color: $very-light-grey
  
  .mobile &
    padding-bottom: vw(15px)

  .top-wrap
    display: flex
    justify-content: space-between
    align-items: center
    padding: vw(30px) 0
    width: 100%

    h3
      margin-block-start: 0
      margin-block-end: 0
      m-font-size(24, 28)
      font-weight: 400

  .pref-noti
    display: flex
    justify-content: space-between
    align-items: center
    margin-bottom: vw(20px)
    padding: vw(15px)
    width: 100%
    border-radius: 4px
    background-color: white
    box-shadow: 0 4px 80px rgba(0, 0, 0, 0.05)

    .pref-info
      display: flex
      flex-direction: column

      .pref-title
        m-font-size(18, 26)
        color: black
        font-weight: 400

      .pref-desc
        m-font-size(14, 22)
        color: black
        font-weight: 300

    .notify-wrap
      display: flex
      align-items: center
      margin-right: vw(8px)
      gap: vw(15px)

      .noti-act
        m-font-size(14, 20)
        color: black
        font-weight: 300

      .switch
        position: relative
        display: inline-block
        width: 40px
        height: 22px

      .switch input
        width: 0
        height: 0
        opacity: 0

      .slider
        position: absolute
        top: 0
        right: 0
        bottom: 0
        left: 0
        background-color: #ccc
        cursor: pointer
        transition: 0.4s
        -webkit-transition: 0.4s

      .slider:before
        position: absolute
        bottom: 2px
        left: 2px
        width: 18px
        height: 18px
        background-color: white
        content: ""
        transition: 0.4s
        -webkit-transition: 0.4s

      input:checked + .slider
        background-color: $grey-dark

      input:focus + .slider
        box-shadow: 0 0 1px $grey-dark

      input:checked + .slider:before
        transform: translateX(18px)
        -webkit-transform: translateX(18px)
        -ms-transform: translateX(18px)

      /* Rounded sliders */
      .slider.round
        border-radius: 34px

      .slider.round:before
        border-radius: 50%

  .pref-wrapper
    display: flex
    justify-content: space-between
    padding: vw(15px)
    width: 100%
    border-radius: 4px
    background-color: white
    box-shadow: 0 4px 80px rgba(0, 0, 0, 0.05)

    .comun-left
      display: flex
      flex-direction: column
      width: 100%
      
      .pref-noti-check
        padding: 0
        border-radius: 0
        background-color: transparent
        box-shadow: none
        margin-bottom: vw(40px)

  .question
    margin-bottom: vw(15px)
    m-font-size(16, 25)

  .comun-noti
    display: flex
    flex-direction: column
    margin-top: vw(20px)
    padding: vw(15px)
    width: 100%
    background-color: white

    .op-wrap
      display: flex
      gap: vw(25px)

    .radio-wrap
      display: flex
      align-items: center
      gap: vw(5px)

      span
        m-font-size(14, 18)
        color: $grey-dark
        font-weight: 400

  .save-button
    display: flex
    align-items: center
    margin: vw(20px) 0 vw(25px)
    padding: vw(6px) vw(20px)
    width: fit-content
    border-radius: 6px
    background-color: black
    color: white
    cursor: pointer

    &:hover
      background-color: $grey-dark

    span
      m-font-size(16, 20)
      font-weight: 400
      
    .mobile &
      width: 100%
      padding: vw(10px) vw(20px)
      justify-content: center
      margin-top: vw(30px)
      
    &.disabled
      background-color: $light-grey
      color: $grey-dark
      box-shadow: 0 0 0 1px $grey-grey inset
      cursor: default
      
</style>